module.exports = __webpack_public_path__ + "img/twitter.c4585ae8.svg";